/** @jsx jsx */
import { css, jsx } from '@emotion/react';
var wrapperStyle = css({
  display: 'flex',
  'span > svg': {
    verticalAlign: 'top'
  }
});
export var IconWrapper = function IconWrapper(_ref) {
  var children = _ref.children;
  return jsx("span", {
    css: wrapperStyle,
    "data-testid": "media-inline-image-card-icon"
  }, children);
};